export const removeDuplicates = (state: any, payload: any) => {
  const oldData = state;
  const newData = payload;
  let filteredDiamonds: {}[] = [];
  newData.map((diamond: any) => {
    const isExist = Boolean(
      oldData.find((info: any) => info._id === diamond._id)
    );
    if (!isExist) {
      filteredDiamonds.push(diamond);
    }
  });
  return filteredDiamonds;
};

export const priceSliderConfig = {
  range: {
    min: 500,
    max: 5000,
  },
  connect: true,
  start: [500, 5000],
  tooltips: true,
};
export const carateSliderConfig = {
  range: {
    min: 0.5,
    max: 10,
  },
  connect: true,
  start: [0.5, 10],
  tooltips: true,
};

const colorMarks = {
  10: "D",
  20: "E",
  30: "F",
  40: "G",
  50: "H",
  60: "I",
  70: "J",
  80: "K",
  90: "L",
};

const cutMarks = {
  10: "Good",
  20: "Very Good",
  30: "Excellent",
  40: "Ideal",
};

const clarityMarks = {
  10: "IF",
  20: "VVS1",
  30: "VVS2",
  40: "VS1",
  50: "VS2",
  60: "SI1",
  70: "SI2",
  80: "SI3",
  90: "I1",
  100: "I2",
  110: "I3",
};

const getValuesByMarks = (marks: { [key: number]: string }) => {
  const length = Object.entries(marks).length;

  // Generate the array with dynamic values starting from 10
  const result = [];
  let value = 10;
  for (let i = 1; i < length + 1; i++) {
    result.push(value * i);
  }

  return result;
};

export const colorSliderConfig = {
  range: {
    min: 0,
    max: 90,
  },

  connect: true,
  start: [0, 90],
  pips: {
    // @ts-ignore
    mode: "values",
    // @ts-ignore
    values: getValuesByMarks(colorMarks), // Place marks at desired positions
    density: 20,
    format: {
      to: (value: number) => {
        //@ts-ignore
        return colorMarks.hasOwnProperty(value) ? colorMarks[value] : "";
      },
    },
  },
  step: 10, // Snap to the nearest mark
};

export const getCutSliderConfig = () => {
  const values = getValuesByMarks(cutMarks);
  return {
    range: {
      min: 0,
      max: [values[values.length - 1]],
    },

    connect: true,
    start: [0, values[values.length - 1]],
    pips: {
      // @ts-ignore
      mode: "values",
      // @ts-ignore
      values, // Place marks at desired positions
      density: 25,
      format: {
        to: (value: number) => {
          //@ts-ignore
          return cutMarks.hasOwnProperty(value) ? cutMarks[value] : "";
        },
      },
    },
    step: 10, // Snap to the nearest mark
  };
};

export const getClaritySliderConfig = () => {
  const values = getValuesByMarks(clarityMarks);
  return {
    range: {
      min: 0,
      max: values[values.length - 1],
    },

    connect: true,
    start: [0, values[values.length - 1]],
    pips: {
      // @ts-ignore
      mode: "values",
      // @ts-ignore
      values, // Place marks at desired positions
      density: 20,
      format: {
        to: (value: number) => {
          //@ts-ignore
          return clarityMarks.hasOwnProperty(value) ? clarityMarks[value] : "";
        },
      },
    },
    step: 10, // Snap to the nearest mark
  };
};

// export function getValuesBetween(obj, start, end) {
//   const result = [];

//   for (const key in obj) {
//     if (key >= start && key <= end) {
//       result.push(obj[key]);
//     }
//   }

//   return result;
// }

export const getSelectedValues = (
  values: Number[],
  marks: { [key: number]: string }
) => {
  const result = [];

  for (const key in marks) {
    const markValue = Number(key);
    if (markValue > Number(values[0]) && markValue <= Number(values[1])) {
      result.push(marks[key]);
    }
  }

  return result;
};